/**
 * Set up routing for all AuditLog views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from '../../global/components/BaseComponent.js.jsx';
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import auditLog views
import AuditLogList from './views/AuditLogList.js.jsx';
import AuditLogDashboard from './views/AuditLogDashboard.js.jsx';

import SingleAuditLog from './views/SingleAuditLog.js.jsx';

class AuditLogRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <YTRoute exact path="/admin/audit-logs" component={AuditLogDashboard} />
        <YTRoute exact path="/admin/audit-logs/:targetType" component={AuditLogDashboard} />
        <YTRoute exact path="/admin/audit-logs/:targetType/:targetId" component={AuditLogList} />

        {/* <YTRoute exact path="/audit-logs/:auditLogId" component={SingleAuditLog}/> */}
      </Switch>
    )
  }
}

export default AuditLogRouter;



// WEBPACK FOOTER //
// modules/auditLog/AuditLogRouter.js.jsx